module.exports = __webpack_public_path__ + "img/star.bc8de0f0.svg";